import {
    ECR_COMPLETED_LOADING,
    ECR_COMPLETED_SUCCESS,
    ECR_COMPLETED_ERROR  
    
    } from "../../actions/ECR/ECRCompletedAction";
    
    const initialState = {
      isSubmitLoading: false
    };
    
    const userReducer = function(state = initialState, action) {
    
      switch (action.type) {
        case ECR_COMPLETED_LOADING: {
          return {
            ...state,
            isSubmitLoading: true
          };
        }
    
        case ECR_COMPLETED_SUCCESS: {
          return {
            ...state,
            isSubmitLoading: false
          };
        }
    
        case ECR_COMPLETED_ERROR: {
          return {
            ...state,
            isSubmitLoading: false
          };
        }
        default: {
          return state;
        }
      }
    };
    
    export default userReducer;
    